import React from 'react';

import VIDABOO_CONSTANTS from '../../config/consts';
import MediaMessageService from '../../services/restServices/mediaMessageService';
//isigal-9 - added next 2 lines
import './mediaMessage.css';
import './sendVoiceMsgComponent.css';
import Draggable from 'react-draggable';
import Timer from './timer/timer';
import redMicImg from '../../../src/assets/svg/icons/icon-mic-red.svg';
import microphone from '../../../src/assets/svg/microphone-off.svg';
import MicrophoneComponent from '../../assets/svgComponents/MicIcon';
import MultiStateButton from '../common/genericComponents/redesign/multiStateButton/multiStateButton';
import ResourcePermissionsComponent from '../common/genericComponents/resourcePermissionsComponent';
import ResourcePermissionsService from '../../services/resourcePermissionsService';

//isigal
class SendVoiceMsgComponent extends React.Component {
  //we don't want to ask rerun initialization on rerendering and avoid sending messages
  constructor(props) {
    super(props);
    this.state = {
      recordBtnPressed: false,
      recordBtnDraggedOverThresh: false,
      enableMediaMessages: false,
      pendingPermissions: false,
      //isigal-9 - added next 3 lines
      recordingTimeExpired: false,
      draggableX: 0,
      draggableY: 0,
      showPermissionsPopup: false,
      permissionStatus: VIDABOO_CONSTANTS.PERMISSION_STATUS.DENIED,
    };

    this.nodeRef = React.createRef();
    this.nodeRef2 = React.createRef();

    this.constraints = {audio: true, video: false};
    this.mediaRecorder = null;

    this.timerRef = React.createRef();
    this.start = 0;
    this.end = 0;
    this.showUploadingLoader = props.showUploadingLoader ?? (() => {});
    this.hideUploadingLoader = props.hideUploadingLoader ?? (() => {});
  }
  componentDidMount = () => {
    // this.checkNavigatorPermissions();
  };

  // checkNavigatorPermissions = async () => {
  //   const permissionObj = await navigator.permissions.query({
  //     name: 'microphone',
  //   });
  //   this.permissionStatus = permissionObj.state;
  //   if (this.permissionStatus === 'granted') {
  //     // this.setState({
  //     //   enableMediaMessages: true
  //     // });
  //   } else {
  //     this.setState({
  //       enableMediaMessages: false,
  //     });
  //   }
  // };

  checkNavigatorPermissionsAndStartRecording = async () => {
    try {
      if (
        this.props.checkIfMessageCanBeSent &&
        !this.props.checkIfMessageCanBeSent()
      ) {
        return;
      }
      const permissionObj =
        await ResourcePermissionsService.quietGetPermissions([
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE,
        ]);
      this.setState({
        permissionStatus:
          permissionObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE],
      });
      if (
        permissionObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE] !==
        VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
      ) {
        this.setState({showPermissionsPopup: true});
      }
      try {
        const stream = await ResourcePermissionsService.loudGetPermissions(
          this.constraints,
          true,
        );
        this.setState({showPermissionsPopup: false});
        this.handleSuccess(stream);
      } catch (error) {
        console.debug('Error: ', error);
        this.setState({showPermissionsPopup: true});
        this.stopRecording();
      }
    } catch (error) {
      //for safari
      try {
        this.setState({
          showPermissionsPopup: true,
        });
        const stream = await ResourcePermissionsService.loudGetPermissions(
          this.constraints,
          true,
        );
        this.setState({
          permissionStatus: VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED,
          showPermissionsPopup: false,
        });
        this.handleSuccess(stream);
      } catch (error) {
        console.debug('Error: ', error);
      }
    }
  };

  //isigal-9 : added next function
  disableMediaRecording = () => {
    this.setState({enableMediaMessages: false, recordingTimeExpired: true});
    this.end = Date.now();
    this.stopRecording();
    this.setState({enableMediaMessages: true, recordingTimeExpired: false});
  };

  handleSuccess = (stream) => {
    try {
      this.mediaStream = stream;
      this.mediaRecorder = new MediaRecorder(stream, {mimeType: 'audio/webm'}); //TODO: Ilan/Jashan -> need to change this for safari browser
      let audioChunks = [];

      this.mediaRecorder.addEventListener('dataavailable', (event) => {
        audioChunks.push(event.data);
      });

      this.mediaRecorder.addEventListener('stop', () => {
        //isigal-9: added next if statement
        let totaltime = this.end - this.start;
        if (!this.cancellMsg && totaltime >= 1000) {
          let audioBlob = new Blob(audioChunks, {type: 'audio/webm'});

          audioChunks = [];

          let reader = new FileReader();
          let base64data;
          //let currentTime = new Date();
          reader.readAsDataURL(audioBlob);
          reader.onloadend = async () => {
            base64data = reader.result;
            // http.saveMediaMessageByChatRoomId(
            //   this.props.chatRoomId,
            //   base64data,
            //   this.props.senderUserId,
            //   this.props.receiverUserId,
            //   this.props.sendAudioMessageNotification,
            // );
            if (!this.props.isDemo) {
              this.showUploadingLoader();
              await MediaMessageService.saveMediaMessageByChatRoomId(
                this.props.senderObjectType,
                this.props.senderObjectId,
                this.props.chatRoomId,
                base64data,
                this.props.sendAudioMessageNotification,
              );
              this.hideUploadingLoader();
            }
          };
        }
        //isigal-9: added next else statement
        else {
          audioChunks = [];
        }
      });
      const audioPreviouslyEnabled =
        this.state.permissionStatus ===
        VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
      this.setState({
        enableMediaMessages: true,
        pendingPermissions: false,
      });

      if (audioPreviouslyEnabled) {
        this.mediaRecorder && this.mediaRecorder.start();
      } else {
        this.stopRecording();
      }
    } catch (error) {
      this.hideUploadingLoader();
      console.debug('Error: ', error);
    }
  };

  //isigal-9 - next 2 functions changed
  startRecording = (event) => {
    event.preventDefault();
    this.start = Date.now();
    this.checkNavigatorPermissionsAndStartRecording();
    this.setState({
      recordBtnPressed: true,
      originDraggableX: event.clientX ?? event.changedTouches[0]?.clientX,
      originDraggableY: event.clientY ?? event.changedTouches[0]?.clientY,
    });

    // this.mediaRecorder && this.mediaRecorder.start();
    this.cancellMsg = false;
    if (!this.props.isDemo) {
      this.props.sendGA(
        this.props.isMentor
          ? VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.CHAT.MENTOR_SENT_AUDIO_MESSAGE
          : VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.CHAT.CLIENT_SENT_AUDIO_MESSAGE,
      );
    }
  };

  stopRecording = () => {
    this.mediaRecorder &&
      this.mediaRecorder.state === 'recording' &&
      this.mediaRecorder.stop();
    this.mediaStream &&
      this.mediaStream.getTracks().forEach((track) => {
        track.stop();
      });
    this.mediaRecorder = null;
    this.setState({recordBtnPressed: false});
    // this.props.deactivateSendVoiceCmp();
  };

  //isigal-9 next 2 functions are new
  cancellRecording = (event) => {
    event.preventDefault();
    const clientX = event.clientX ?? event.changedTouches[0]?.clientX;
    const clientY = event.clientY ?? event.changedTouches[0]?.clientY;

    this.setState({draggableX: clientX, draggableY: clientY});
    // console.debug(event.clientX);
    if (this.state.originDraggableX - clientX > 150)
      this.setState({recordBtnDraggedOverThresh: true});
    else {
      this.setState({recordBtnDraggedOverThresh: false});
    }
  };

  stopDragging = (event) => {
    this.end = Date.now();

    const clientX = event.clientX ?? event.changedTouches[0]?.clientX;
    if (this.state.originDraggableX - clientX > 150) {
      // cancel the msg send

      this.cancellMsg = true;
    }
    this.setState({
      draggableX: 0,
      draggableY: 0,
      recordBtnDraggedOverThresh: false,
      draggableResetKey: Date.now(),
    });

    this.stopRecording();
  };

  closePermissionPopup = () => {
    this.setState({showPermissionsPopup: false});
  };

  // deactivateSendVoiceCmp = () => {
  //   if (VIDABOO_CONSTANTS.NATIVE_APP) {
  //     return;
  //   }
  //   let sendBoxEl;
  //   let sendVoiceMsgEl = document.getElementById('et-send-voice-cmp-id');
  //   if (this.props.fldObj.isMentor) {
  //     sendBoxEl = document.getElementById('et-chetting-keyborad-id');
  //   } else {
  //     sendBoxEl = document.getElementById('et-send-speaker-box-id');
  //   }
  //   sendVoiceMsgEl.style.visibility = 'hidden';
  //   sendBoxEl.style.visibility = 'visible';
  // };

  //isigal-9: all the html changed
  render() {
    return this.props.showNewUI ? (
      <div className="et-v2-send-voice-msg-container">
        {this.state.showPermissionsPopup && (
          <ResourcePermissionsComponent
            permissionsStatusesObj={{
              [VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE]:
                this.state.permissionStatus,
            }}
            closePopUp={this.closePermissionPopup}
            onPermissionsSuccess={this.closePermissionPopup}
          />
        )}
        {this.state.recordBtnPressed && (
          <div
            className="et-svmc-timer-slide-to-cancel-txt-wrap"
            id="et-send-voice-cmp-id">
            {this.state.enableMediaMessages ? (
              <>
                <Timer
                  timerDuration={VIDABOO_CONSTANTS.MEDIA_MESSAGE.MAX_MSG_TIME}
                  execUponExpiration={this.disableMediaRecording}
                  isMentor={this.props.isMentor}
                />
                <div className="et-draggable-bar" id="et-draggable-bar-id">
                  <div className="et-svmc-arrow-slide-to-cancel-txt-wrap">
                    <i className="et-svmc-slide-left-arrow fas fa-arrow-left" />
                    <div className="et-svmc-slide-to-cancel-txt">
                      Slide to cancel
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className={'et-svmc-allow-microphone-txt'}>
                Please allow microphone
              </div>
            )}
            {this.state.recordingTimeExpired && (
              <button className="et-btnClass">
                <img
                  src={microphone}
                  className="et-smiley-record-send-icon "
                  alt="record2"
                />
              </button>
            )}
          </div>
        )}
        <Draggable
          key={this.state.draggableResetKey}
          nodeRef={this.nodeRef}
          onDrag={this.cancellRecording}
          onStart={this.startRecording}
          onStop={this.stopDragging}
          bounds={{top: 0, bottom: 0, right: 0, left: -190}}
          position={{
            x: this.state.draggableX,
            y: this.state.draggableY,
          }}>
          <div
            ref={this.nodeRef}
            id="microphone"
            className={`et-svmc-mic-btn ${this.state.recordBtnPressed && this.state.enableMediaMessages ? 'et-svmc-mic-btn-with-blink-anim' : ''} ${this.state.recordBtnDraggedOverThresh ? 'et-svmc-mic-btn-error' : ''}`}>
            <MultiStateButton
              leftImage={
                <MicrophoneComponent
                  fillColor={
                    this.state.recordBtnPressed &&
                    this.state.enableMediaMessages
                      ? '#fd3c3b'
                      : 'var(--et-mentor-input-field-bubble-text-color)'
                  }
                />
              }
            />
          </div>
        </Draggable>
      </div>
    ) : (
      <>
        {this.state.recordBtnPressed && (
          <div
            className={
              this.props.isMentor
                ? 'et-send-voice-cmp'
                : 'et-send-voice-cmp et-send-voice-cmp-client'
            }
            id="et-send-voice-cmp-id">
            {this.state.enableMediaMessages ? (
              <>
                <img
                  src={redMicImg}
                  id="record-mic"
                  className="et-voice-area-icon-recording fa-blink"
                  alt="record"></img>
                <Timer
                  timerDuration={VIDABOO_CONSTANTS.MEDIA_MESSAGE.MAX_MSG_TIME}
                  execUponExpiration={this.disableMediaRecording}
                  isMentor={this.props.isMentor}
                />

                <div
                  className={
                    this.props.isMentor
                      ? 'et-draggable-bar'
                      : 'et-draggable-bar et-draggable-bar-client'
                  }
                  id="et-draggable-bar-id">
                  <span
                    className={
                      this.props.isMentor
                        ? 'et-drag-text'
                        : 'et-drag-text et-drag-text-client'
                    }>
                    <i className="et-record-cancell-icon fas fa-arrow-left" />
                    Slide to cancel
                  </span>
                </div>
              </>
            ) : (
              <span
                className={
                  this.props.isMentor ? 'et-drag-text' : 'et-drag-text-client'
                }>
                Please allow microphone
              </span>
            )}

            {this.state.pendingPermissions && (
              <button className="et-btnClass">
                <img
                  src={microphone}
                  className="et-smiley-record-send-icon "
                  alt="record1"
                />{' '}
              </button>
            )}
            {this.state.recordingTimeExpired && (
              <button className="et-btnClass">
                <img
                  src={microphone}
                  className="et-smiley-record-send-icon "
                  alt="record2"
                />{' '}
              </button>
            )}
          </div>
        )}
        {this.state.showPermissionsPopup && (
          <ResourcePermissionsComponent
            permissionsStatusesObj={{
              [VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE]:
                this.state.permissionStatus,
            }}
            closePopUp={this.closePermissionPopup}
            onPermissionsSuccess={this.closePermissionPopup}
          />
        )}
        <Draggable
          key={this.state.draggableResetKey}
          nodeRef={this.nodeRef2}
          onDrag={this.cancellRecording}
          onStart={this.startRecording}
          onStop={this.stopDragging}
          bounds={{top: 0, bottom: 0, right: 0, left: -190}}>
          <div
            ref={this.nodeRef2}
            id="microphone"
            className={
              this.state.recordBtnDraggedOverThresh
                ? 'et-smiley-record-send-icon et-smiley-record-red-border'
                : this.state.recordBtnPressed
                  ? 'et-smiley-record-send-icon-pressed'
                  : 'et-smiley-record-send-icon'
            }>
            <MicrophoneComponent
              fillColor={
                this.props.isMentor
                  ? '#606060'
                  : 'var(--et-mentor-input-field-bubble-text-color)'
              }
            />
          </div>
          {/* <img
            src={microphone}
            className={
              this.state.recordBtnDraggedOverThresh
                ? 'et-smiley-record-send-icon et-smiley-record-red-border'
                : this.state.recordBtnPressed
                ? 'et-smiley-record-send-icon-pressed'
                : 'et-smiley-record-send-icon'
            }
            alt="record3"
            id="microphone"
          /> */}
        </Draggable>
      </>
    );
  }
}

export default SendVoiceMsgComponent;
